/** 관리자 콘솔 공용 헬퍼 (§3.2) — 내부 운영 화면 전용 */

export function formatWon(value: number): string {
  return `${value.toLocaleString('ko-KR')}원`;
}

export function formatCount(value: number): string {
  return value.toLocaleString('ko-KR');
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return '-';
  if (bytes < 1024) return `${bytes}B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value >= 100 ? Math.round(value) : value.toFixed(1)}${units[unit]}`;
}

export function formatUptime(seconds: number): string {
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3_600);
  const minutes = Math.floor((seconds % 3_600) / 60);
  if (days > 0) return `${days}일 ${hours}시간`;
  if (hours > 0) return `${hours}시간 ${minutes}분`;
  return `${minutes}분`;
}

export const FACILITY_STATUS_LABELS: Record<string, string> = {
  PENDING: '승인 대기',
  APPROVED: '운영 중',
  REJECTED: '반려',
  SUSPENDED: '정지',
};

export const BILLING_TYPE_LABELS: Record<string, string> = {
  QUOTE: '견적서',
  STATEMENT: '거래명세서',
};

export const DELIVERY_CHANNEL_LABELS: Record<string, string> = {
  IN_APP: '인앱',
  PUSH: '푸시',
  ALIMTALK: '알림톡',
  SMS: '문자',
  EMAIL: '이메일',
};
